// Mirrors backend: core/workflow/incept/Ppsr/Enums/SerialNumberType.php
export enum SerialNumberType {
  Unsupported = 'unsupported',
  UnknownMotorVehicleIdentifier = 'unknown_motor_vehicle_identifier',
  VIN = 'vin',
  ChassisNumber = 'chassis_number',
  MVManufacturersNumber = 'mv_manufacturers_number',
  HIN = 'hin',
  OfficialNumber = 'official_number',
  AircraftManufNumber = 'aircraft_manuf_number',
  AirframeManufNumber = 'airframe_manuf_number',
  HelicopterManufNumber = 'helicopter_manuf_number',
  AircraftNationalityCodeAndRegMark = 'aircraft_nationality_code_and_reg_mark',
  PatentNumber = 'patent_number',
  TrademarkNumber = 'trademark_number',
  DesignNumber = 'design_number',
  PlantBreedersRightNumber = 'plant_breeders_right_number',
}

export const SERIAL_NUMBER_TYPE_LABELS: Record<SerialNumberType, string> = {
  [SerialNumberType.Unsupported]: 'Unsupported',
  [SerialNumberType.UnknownMotorVehicleIdentifier]:
    'Unknown Motor Vehicle Identifier',
  [SerialNumberType.VIN]: 'VIN',
  [SerialNumberType.ChassisNumber]: 'Chassis Number',
  [SerialNumberType.MVManufacturersNumber]: "MV Manufacturer's Number",
  [SerialNumberType.HIN]: 'HIN',
  [SerialNumberType.OfficialNumber]: 'Official Number',
  [SerialNumberType.AircraftManufNumber]: 'Aircraft Manuf Number',
  [SerialNumberType.AirframeManufNumber]: 'Airframe Manuf Number',
  [SerialNumberType.HelicopterManufNumber]: 'Helicopter Manuf Number',
  [SerialNumberType.AircraftNationalityCodeAndRegMark]:
    'Aircraft Nationality Code And Reg Mark',
  [SerialNumberType.PatentNumber]: 'Patent Number',
  [SerialNumberType.TrademarkNumber]: 'Trademark Number',
  [SerialNumberType.DesignNumber]: 'Design Number',
  [SerialNumberType.PlantBreedersRightNumber]: 'Plant Breeders Right Number',
};
